import {get as _get} from 'lodash';
import initialstate from '../initialstate';

import {HttpStatusCodes} from '../../util/uiconstants';
import normalizeActivityLogData from './normalizers/normalizeActivityLogData';
import normalizeTableConfig from './normalizers/normalizeTableConfig';

import {GET_ACTIVITY_LOG, GET_ACTIVITY_LOG_EXPORT_DATA} from '../../actions/actiontypes';

export const activityLogReducer = (state = initialstate.activityLog, action) => {
	switch (action.type) {
		case GET_ACTIVITY_LOG: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const {lastRefreshed = '', data = [], ...rest} = action?.response;
				let tableConfig = {...rest};
				if (!tableConfig.orderBy) tableConfig.orderBy = action?.payload?.orderBy;
				if (!tableConfig.orderByAscending) tableConfig.orderByAscending = action?.payload?.orderByAscending;
				return {
					...state,
					lastRefreshed,
					data: normalizeActivityLogData(data),
					...normalizeTableConfig(tableConfig)
				};
			}
			return {
				...state,
				lastRefreshed: '',
				data: []
			};
		}
		case GET_ACTIVITY_LOG_EXPORT_DATA: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const response = _get(action, 'responseObj.data', []);
				return {
					...state,
					exportData: normalizeActivityLogData(response.data)
				};
			}
			return {
				...state,
				exportData: []
			};
		}
		default: {
			return state;
		}
	}
};
